var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h2',{staticClass:"mb-0"},[(_vm.item.title)?_c('button',{class:{ 'active': _vm.isActive },attrs:{"aria-expanded":_vm.isActive ? 'true' : 'false'},on:{"click":_vm.handleClick}},[_vm._v("\n        "+_vm._s(_vm.item.title)+"\n    ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }